import { Injectable } from '@angular/core';
import {
  ContentFeedNotification,
  NotificationStaticContent
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { TabsOptions } from '@com-delta-omnichannel/mach-core-js';
import { NOTIFICATION } from '../../constants/common/common.constants';
import {
  HeaderFooterMachCore,
  NotificationAem
} from '../../models/header-footer-mach-core';
import { checkStringValueNull } from '../../utils/common/common.utils';
import { getAuxiliaryNavigation } from '../../utils/header-footer-content/header-footer-content.utils';

@Injectable({
  providedIn: 'root'
})
export class NotificationAdapterService {
  getContent(content: HeaderFooterMachCore): ContentFeedNotification {
    return {
      advisories: content.advisories.AdvisoriesList,
      news: [],
      staticContent: this.getStaticContent(content),
      showEmptyMessageNews: false,
      tabElement: this.createTabElement(content)
    };
  }

  createTabElement(content: HeaderFooterMachCore): TabsOptions {
    const notification = getAuxiliaryNavigation(
      content,
      NOTIFICATION
    ) as NotificationAem;
    const advisoryId = checkStringValueNull(
      notification?.newsLabel
    ).toLowerCase();
    const advisoryLabel = this.transformToTitleCase(
      checkStringValueNull(notification?.advisioriesLabel)
    );

    const newsId = checkStringValueNull(notification?.newsLabel).toLowerCase();
    const newsLabel = this.transformToTitleCase(
      checkStringValueNull(notification?.newsLabel)
    );
    return {
      id: 'tabs-width-fixed-small',
      tabVariant: 'standard',
      tabSize: 'small',
      tabWidth: 'fixed',
      tabItems: [
        {
          id: advisoryId,
          label: advisoryLabel,
          value: advisoryLabel,
          selected: true
        },
        {
          id: newsId,
          label: newsLabel,
          value: newsLabel,
          selected: false
        }
      ]
    };
  }

  getStaticContent(content: HeaderFooterMachCore): NotificationStaticContent {
    const notification = getAuxiliaryNavigation(
      content,
      NOTIFICATION
    ) as NotificationAem;

    return {
      label: checkStringValueNull(notification?.label),
      feedLabel: this.transformToTitleCase(
        checkStringValueNull(notification?.feedLabel)
      ),
      advisoriesLabel: checkStringValueNull(notification?.advisioriesLabel),
      advisoriesViewAllLink: checkStringValueNull(
        notification?.advisioriesViewAllLink
      ),
      advisoriesViewNewWindow: checkStringValueNull(
        notification?.advisoriesViewNewWindow
      ),
      newsLabel: checkStringValueNull(notification?.newsLabel),
      newsViewAllLink: checkStringValueNull(notification?.newsViewAllLink),
      newsViewNewWindow: checkStringValueNull(notification?.newsViewNewWindow),
      viewAllLabel: checkStringValueNull(notification?.newsViewAllLabel),
      advisoriesViewAllLabel: checkStringValueNull(
        notification?.advisoriesViewAllLabel
      ),
      noAdvisoriesLabel: checkStringValueNull(notification?.noAdvisoriesLabel),
      noNewsLabel: checkStringValueNull(notification?.noNewsLabel),
      screenReaderViewAllAdvisories: checkStringValueNull(
        notification?.screenReaderViewAllAdvisories
      ),
      screenReaderViewAllNews: checkStringValueNull(
        notification?.screenReaderViewAllNews
      ),
      screenReaderOpenNewTabLabel: checkStringValueNull(
        notification?.screenReaderOpenNewTabLabel
      ),
      screenReaderNotificationAvailableLabel: checkStringValueNull(
        notification?.screenReaderNotificationAvailableLabel
      ),
      loadingLabel: checkStringValueNull(notification?.loadingLabel)
    };
  }

  transformToTitleCase(str: string): string {
    if (str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
}
